import { createFileRoute } from "@tanstack/react-router";
import { siteTitle, siteUrl } from "@/config/site";
import { LoginPage } from "@/components/auth/login-page";
import { parseOidcUid } from "@/lib/oidc-handoff";
import { headMessage } from "@/lib/i18n";

type LoginSearch = { next?: string; oidc?: string };

export const Route = createFileRoute("/($locale)/auth/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    next: typeof search.next === "string" ? search.next : undefined,
    oidc: parseOidcUid(search.oidc),
  }),
  head: ({ matches }) => {
    const canonicalUrl = `${siteUrl}/auth/login`;
    return {
      meta: [
        { title: `${headMessage(matches, "auth.login.metaTitle")} | ${siteTitle}` },
        { name: "description", content: headMessage(matches, "auth.login.metaDescription") },
        { name: "robots", content: "noindex,follow" },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: function LoginRoute() {
    const { next, oidc } = Route.useSearch();
    return <LoginPage nextPath={next ?? "/"} oidcUid={oidc} />;
  },
});
